import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.reissue.both');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-page-reissue-both',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.reissue.both/view.scss */
:host {
  display: block;
  height: 100%;
}

.recovery-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100svh;
  padding: 88px 24px 48px;
  background: #f3f6fb;
  color: #25324c;
}

.recovery-shell {
  width: 100%;
  max-width: 480px;
}

.recovery-brand {
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
}

.recovery-brand img {
  display: block;
  width: 112px;
  height: auto;
}

.recovery-card {
  overflow: hidden;
  border: 1px solid #e7edf6;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 20px 65px -30px rgba(35, 55, 103, 0.22);
}

.recovery-heading {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 30px 34px 27px;
  border-bottom: 1px solid #edf1f7;
}

.recovery-symbol {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 48px;
  height: 48px;
  border: 1px solid #dfebf6;
  border-radius: 15px;
  background: #edf5fc;
  color: #2d70a6;
  font-size: 19px;
}

.recovery-heading-text {
  min-width: 0;
}

.recovery-eyebrow {
  margin: 0 0 5px;
  color: #748299;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.recovery-title {
  margin: 0;
  color: #1d2c48;
  font-size: 25px;
  font-weight: 750;
  letter-spacing: -0.8px;
  line-height: 1.4;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.recovery-body {
  padding: 28px 34px 32px;
}

.recovery-fields {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.recovery-field label {
  display: block;
  margin-bottom: 9px;
  color: #34415a;
  font-size: 13px;
  font-weight: 650;
}

.recovery-input {
  position: relative;
}

.recovery-field-icon {
  position: absolute;
  left: 17px;
  top: 19px;
  color: #8a98ae;
  font-size: 15px;
  pointer-events: none;
}

.recovery-field input {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 54px;
  padding: 0 16px 0 45px;
  border: 1px solid #e3e9f2;
  border-radius: 13px;
  outline: none;
  background: #f7f9fc;
  color: #25324c;
  font: inherit;
  font-size: 14px;
  transition: border-color 0.18s, box-shadow 0.18s;
}

.recovery-field input::placeholder {
  color: #8a97ab;
  opacity: 1;
}

.recovery-field input:focus {
  background: #fff;
  border-color: #387dc1;
  box-shadow: 0 0 0 3px rgba(56, 125, 193, 0.1215686275);
}

.recovery-error {
  display: block;
  margin-top: 7px;
  color: #b54747;
  font-size: 12px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.recovery-code-field {
  padding-top: 22px;
  border-top: 1px solid #edf1f7;
}

.recovery-code {
  font-variant-numeric: tabular-nums;
  letter-spacing: 5px;
}

.recovery-code::placeholder {
  letter-spacing: 0;
}

.recovery-actions {
  margin-top: 28px;
}

.recovery-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  width: 100%;
  min-height: 52px;
  padding: 13px 18px;
  border: 0;
  border-radius: 26px;
  background: linear-gradient(105deg, #137db9, #303783);
  box-shadow: 0 6px 14px rgba(41, 75, 148, 0.1490196078);
  color: #fff;
  font: inherit;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.6;
  cursor: pointer;
  transition: filter 0.18s, box-shadow 0.18s;
}

.recovery-submit i {
  flex-shrink: 0;
  font-size: 12px;
  opacity: 0.85;
}

.recovery-submit:hover {
  filter: brightness(1.1);
  box-shadow: 0 8px 20px rgba(41, 75, 148, 0.2196078431);
}

.recovery-submit:focus-visible, .recovery-resend:focus-visible {
  outline: 2px solid #2685c0;
  outline-offset: 4px;
}

.recovery-resend-row {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.recovery-resend {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  color: #597799;
  font-size: 12px;
  font-weight: 550;
  line-height: 1.6;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}

.recovery-resend:hover {
  color: #255e99;
  text-decoration: underline;
  text-underline-offset: 4px;
}

@media (max-width: 540px) {
  .recovery-page {
    padding: 86px 20px 32px;
  }
  .recovery-brand {
    margin-bottom: 24px;
  }
  .recovery-card {
    border-radius: 24px;
  }
  .recovery-heading {
    gap: 13px;
    padding: 25px 24px 23px;
  }
  .recovery-symbol {
    flex-basis: 42px;
    height: 42px;
    border-radius: 13px;
    font-size: 17px;
  }
  .recovery-title {
    font-size: 23px;
  }
  .recovery-body {
    padding: 25px 24px 27px;
  }
  .recovery-field input {
    font-size: 16px;
  }
}
@media (max-width: 360px) {
  .recovery-page {
    padding-left: 12px;
    padding-right: 12px;
  }
  .recovery-heading {
    padding-left: 20px;
    padding-right: 20px;
  }
  .recovery-title {
    font-size: 21px;
  }
  .recovery-body {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .recovery-field input, .recovery-submit {
    transition: none;
  }
}
.recovery-expiry {
  margin-top: 9px;
  color: #597799;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  line-height: 1.6;
}

.recovery-expiry.is-expired {
  color: #b54747;
}

.recovery-resend {
  border: 0;
  background: transparent;
  font-family: inherit;
}

.recovery-submit:disabled, .recovery-resend:disabled {
  cursor: default;
  opacity: 0.55;
}`],
})
export class PageReissueBothComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public data: any = {
        account_name: '',
        email: '',
        onetimepass: '',
        verify: false,
        verified: false
    };

    public errorMessages: any = {};
    public busy = false;


    public emailSeconds: number | null = null;
    public resendSeconds = 0;
    private emailTimer: ReturnType<typeof setInterval> | null = null;
    private destroyed = false;

    public get emailTimeLeft(): string {
        const seconds = this.emailSeconds ?? 0;
        return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    }

    private stopEmailClock() {
        if (this.emailTimer !== null) clearInterval(this.emailTimer);
        this.emailTimer = null;
        this.emailSeconds = null;
        this.resendSeconds = 0;
    }

    private syncEmailClock(data: any) {
        this.stopEmailClock();
        if (this.destroyed || !Number.isFinite(data?.email_code_expires_at)
            || !Number.isFinite(data?.server_time) || !Number.isFinite(data?.resend_at)) return;
        const deadline = performance.now() + Math.max(0, data.email_code_expires_at - data.server_time) * 1000;
        const resendAt = performance.now() + Math.max(0, data.resend_at - data.server_time) * 1000;
        const tick = () => {
            this.emailSeconds = Math.max(0, Math.ceil((deadline - performance.now()) / 1000));
            this.resendSeconds = Math.max(0, Math.ceil((resendAt - performance.now()) / 1000));
            if (this.emailSeconds === 0 && this.resendSeconds === 0 && this.emailTimer !== null) {
                clearInterval(this.emailTimer);
                this.emailTimer = null;
            }
            this.service.render();
        };
        tick();
        if (this.emailSeconds > 0 || this.resendSeconds > 0) this.emailTimer = setInterval(tick, 1000);
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.stopEmailClock();
    }

    public async ngOnInit() {
        await this.service.init();
        // Public recovery pages must release the initial loading overlay on direct entry.
        this.service.auth.allow();
        const response = await this.request('getRecoveryState');
        if (response.code === 200 && (response.data?.pending || response.data?.verify)) {
            Object.assign(this.data, response.data, { verify: true });
            if (!response.data.pending) this.syncEmailClock(response.data);
        }
        await this.service.render();
    }

    private async request(action: string, params: any = {}) {
        try {
            return await wiz.call(action, params, { timeout: 135000 });
        } catch (error) {
            return { code: 503, data: { message: '요청을 확인하지 못했습니다. 다시 시도해주세요.', retry: true } };
        }
    }

    public async sendEmailVerification() {
        if (this.busy || this.data.pending || this.resendSeconds > 0) return;
        this.busy = true;
        await this.service.render();
        this.service.loading.show();
        const response = await this.request('emailAuthentication', {
            account_name: this.data.account_name, email: this.data.email
        });
        this.busy = false;
        this.service.loading.hide();
        if (response.code === 200) {
            this.data.verify = true;
            this.data.onetimepass = '';
            this.syncEmailClock(response.data);
            await this.service.alert.success('이메일 인증 코드가 발송되었습니다.');
        } else {
            await this.service.alert.error(response.data?.message || response.data || '인증메일 발송에 실패했습니다.');
        }
        await this.service.render();
    }

    public async verifyAndReissueBoth() {
        if (this.busy) return;
        this.busy = true;
        await this.service.render();
        this.service.loading.show();
        const response = await this.request('verifyAndReissueBoth', {
            account_name: this.data.account_name, email: this.data.email,
            onetimepass: this.data.onetimepass
        });
        this.busy = false;
        this.service.loading.hide();
        if (response.code === 200) {
            this.data.onetimepass = '';
            this.stopEmailClock();
            await this.service.alert.success('초기화가 완료되었습니다. 이메일로 발송된 초기 비밀번호로 로그인해주세요.');
            this.router.navigate(['/login']);
        } else {
            if (response.data?.retry) { this.data.pending = true; this.stopEmailClock(); }
            if (response.code === 401) { this.data.pending = false; this.data.verify = false; this.stopEmailClock(); }
            await this.service.alert.error(response.data?.message || response.data || '초기화에 실패했습니다.');
        }
        await this.service.render();
    }
}

export default PageReissueBothComponent;